import { Navigate, Route, Routes } from "react-router-dom";
import { Dealer } from "./Dealer";
import { LoadingScreen } from "./components/LoadingScreen";
import { useDealerSession } from "./lib/session";
import { Login } from "./pages/Login";
import { Dashboard } from "./pages/Dashboard";
import { Agents } from "./pages/Agents";
import { SendFloat } from "./pages/SendFloat";
import { BankTopup } from "./pages/BankTopup";
import { Transactions } from "./pages/Transactions";
import { Commissions } from "./pages/Commissions";
import { Statement } from "./pages/Statement";
import { Settings } from "./pages/Settings";

function Protected({ children }: { children: React.ReactNode }) {
  const { dealer, loading } = useDealerSession();
  if (loading) return <LoadingScreen />;
  if (!dealer) return <Navigate to="/login" replace />;
  return <>{children}</>;
}

function NotFound() {
  return (
    <div className="ev-empty" style={{ minHeight: 360 }}>
      <strong className="ev-h3">Page not found</strong>
      <p className="ev-caption">The page you were looking for has moved or never existed.</p>
      <a className="ev-btn ev-btn-sm ev-btn-secondary" href="/">
        Back to dashboard
      </a>
    </div>
  );
}

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        element={
          <Protected>
            <Dealer />
          </Protected>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="agents" element={<Agents />} />
        <Route path="send" element={<SendFloat />} />
        <Route path="topup" element={<BankTopup />} />
        <Route path="transactions" element={<Transactions />} />
        <Route path="commissions" element={<Commissions />} />
        <Route path="statement" element={<Statement />} />
        <Route path="settings" element={<Settings />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}
